declare namespace $ {

	export class $shm_hitalama_dragtree_toggle extends $mol_check_expand {
		pointerdown( next?: any ): any
		event( ): ({ 
			pointerdown( next?: ReturnType< $shm_hitalama_dragtree_toggle['pointerdown'] > ): ReturnType< $shm_hitalama_dragtree_toggle['pointerdown'] >,
		})  & ReturnType< $mol_check_expand['event'] >
	}
	
}

//# sourceMappingURL=toggle.view.tree.d.ts.map